'use client';

import { ReactNode, useContext } from 'react';
import { MobileDetectContext } from './mobile-detect-context';
interface MobileDetectProviderProps {
  children: ReactNode;
  isMobile: boolean;
}
export const MobileDetectProvider = ({
  children,
  isMobile
}: MobileDetectProviderProps) => {
  return <MobileDetectContext.Provider value={{
    isMobile
  }} data-sentry-element="unknown" data-sentry-component="MobileDetectProvider" data-sentry-source-file="mobile-detect-provider.tsx">{children}</MobileDetectContext.Provider>;
};
export const useMobileDetect = () => {
  const context = useContext(MobileDetectContext);
  if (context === undefined) {
    throw new Error('useMobileDetect must be used within a MobileDetectProvider');
  }
  return context;
};